import { apiSlice } from "app/api/apiSlice"


export const devicesStatusApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // HR
        getDevicesStatus: builder.query({
            query: () => {
                return {
                    url: 'devices/status',
                    method: 'GET'
                }
            },
            providesTags: ['device']
        }),
        // PUT Device New Status
        setDeviceStatus: builder.mutation({
            query: ({
                deviceGuid,
                enabled
            }) => ({
                url: 'devices/status',
                method: 'POST',
                params: {
                    enabled: enabled,
                    deviceGuid: deviceGuid
                }
            }),
            invalidatesTags: ['device']
        }),
        // DELETE Device
        deleteDevice: builder.mutation({
            query: (deviceGuid) => ({
                url: 'devices',
                method: 'DELETE',
                params: { deviceGuid: deviceGuid }
            }),
            invalidatesTags: ['device']
        }),
    })
})

export const {
    useGetDevicesStatusQuery,
    useLazyGetDevicesStatusQuery,
    useSetDeviceStatusMutation,
    useDeleteDeviceMutation
} = devicesStatusApiSlice